import script from "./list-select.vue?vue&type=script&lang=ts&setup=true"
export * from "./list-select.vue?vue&type=script&lang=ts&setup=true"

import "./list-select.vue?vue&type=style&index=0&id=4562d302&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4562d302"]])

export default __exports__